import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

export interface TermsDialogData {
    language?: string;
}

@Component({
    selector: 'app-terms-dialog',
    templateUrl: './terms-dialog.component.html',
    styleUrls: ['./terms-dialog.component.scss'],
    standalone: false,
})
export class TermsDialogComponent implements OnInit {
    tosText: string = '';
    currentLanguage: string;
    loading: boolean = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TermsDialogData,
        public dialogRef: MatDialogRef<TermsDialogComponent>,
        private httpClient: HttpClient,
        private translateService: TranslateService
    ) {
        this.currentLanguage =
            data?.language || this.translateService.currentLang || 'de';
    }

    ngOnInit(): void {
        this.loadTermsOfService(this.currentLanguage);
    }

    async loadTermsOfService(lang: string): Promise<void> {
        try {
            this.loading = true;
            this.tosText = await lastValueFrom(
                this.httpClient.get(`assets/tos/${lang}.txt`, {
                    responseType: 'text',
                })
            );
        } catch (error) {
            // Fallback to German if language file doesn't exist
            if (lang !== 'de') {
                this.tosText = await lastValueFrom(
                    this.httpClient.get('assets/tos/de.txt', {
                        responseType: 'text',
                    })
                );
            } else {
                this.tosText = 'Error loading terms of service.';
            }
        } finally {
            this.loading = false;
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
